<template>
  <div class="channel_list">
    <!--渠道列表头部-->
    <div class="channel_list_top">
      <div class="wper15"><input type="text" v-model.trim="numOrName" title="渠道编号/名称" placeholder="渠道编号/名称"></div>
      <div>
        <el-select v-model.trim="selectChannelType" placeholder="渠道类型">
          <el-option
            v-for="item in channelType"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model.trim="selectReSales" placeholder="允许售后">
          <el-option
            v-for="item in isReSales"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <!--锁定状态-->
     <!-- <div>
        <el-select v-model.trim="selectLockedStatus" placeholder="请选择">
          <el-option
            v-for="item in LockedStatus"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>-->
      <div class="w46">配货率:</div>
      <div class="wper13">
        <el-select v-model.trim="selectDistributionType" placeholder="配货率类型">
          <el-option
            v-for="item in distributionType"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="w70">
        <el-select v-model.trim="selectSymbolType" placeholder="符号">
          <el-option
            v-for="item in symbolType"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="wper5"><input type="text" v-model.trim="num" title="数值"></div>
      <div class="wper19"><input type="checkbox" v-model="todayDeliveryChannel" id="today_delivery_channel"><label for="today_delivery_channel">显示今天提供发货的渠道</label>
      </div>
      <button class="btn_normal w116" @click="queryData()">查询</button>
    </div>

    <!--渠道列表信息-->
    <div class="channel_list_msg">
      <!--表格-->
      <table class="table">
        <thead>
        <tr>
          <th>渠道编号</th>
          <th>渠道名称</th>
          <th>渠道类型</th>
          <th>承诺配货率</th>
          <th>实际配货率</th>
          <!--<th>锁定状态</th>-->
          <th>截单时间</th>
          <th>？允许售后</th>
          <th>库存更新时间</th>
          <th>？今日发货</th>
          <th>？售后自收</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-if="list.length">
        <tr v-for="(item, index) in list" :key="index">
          <td>{{item.StoreroomCode}}</td>
          <td>{{item.StoreroomName}}</td>
          <td>{{item.StoreroomType | channeltype}}</td>
          <td v-if="item.PromiseSendRate">{{item.PromiseSendRate}}%</td>
          <td v-if="!item.PromiseSendRate"></td>
          <td v-if="item.RealSendRate || item.RealSendRate === 0">{{item.RealSendRate}}%</td>
          <td v-if="!item.RealSendRate && item.RealSendRate !== 0"></td>
          <!--<td>{{item.LockStatus | lockstatus}}</td>-->
          <td>{{item.StopJiaoDanString}}</td>
          <td>{{item.IsReOrder | aftersale}}</td>
          <td v-if="!item.StockUpdateTime">{{item.StockUpdateTime}}</td>
          <td v-if="item.StockUpdateTime">{{item.StockUpdateTime | time}}</td>
          <td>{{item.IsTodayDelivery | istodaydelivery}}</td>
          <td>{{item.AfteSale}}</td>
          <td>
            <a class="mr5" title="查看渠道详情" @click="ctrlBtn('channelDetail', item)">查看渠道详情</a>
            <a v-if="item.AfteSale === '否'" title="自收按钮" @click="ctrlBtn('openAfterSale', item)">开启自收</a>
            <a v-if="item.AfteSale === '是'" title="自收按钮" @click="ctrlBtn('closeAfterSale', item)">关闭自收</a>
          </td>
        </tr>
       <!-- <tr>
          <td>WZ_GZDFC</td>
          <td>WZ_广州代发仓</td>
          <td>非现货仓</td>
          <td>85.00%</td>
          <td>75.00%</td>
          <td>停用</td>
          <td>17:30</td>
          <td>否</td>
          <td><a title="查看渠道详情" @click="ctrlBtn('channelDetail', 'item')">查看渠道详情</a></td>
        </tr> -->
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="11">暂时没有相关的内容</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div v-if="list.length" class="text_right mt20">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <channel-list-embed-msg v-if="isShow"
                            :title="dialogTitle"
                            :channelMsg="channelMsg"
                            :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></channel-list-embed-msg>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script type="es6">
  import ChannelListEmbedMsg from './channel-list-embed-msg';
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'channel-list',
    components: {ChannelListEmbedMsg, MsgDialog, LoadingDialog},
    data() {
      return {
        list: [], // 渠道列表
        channelMsg: '', // 渠道信息
        numOrName: '', // 渠道编号/名称
        selectChannelType: 0, //  选择的渠道类型
        channelType: [
          {id: 0, text: '渠道类型'},
          {id: 1, text: '实仓'},
          {id: 2, text: '虚仓'}
        ], // 渠道类型下拉列表
        selectReSales: null, // 选择的允许售后的类型
        isReSales: [
          {id: null, text: '允许售后'},
          {id: true, text: '是'},
          {id: false, text: '否'}
        ], // 允许售后的下拉列表
       /* selectLockedStatus: 0, // 选择的锁定状态
        LockedStatus: [
          {id: 0, text: '锁定状态'},
          {id: 2, text: '停用'},
          {id: 1, text: '启用'}
        ], // 锁定状态下拉列表 */
        selectDistributionType: 0, // 选择的配货率类型
        distributionType: [
          {id: 0, text: '类型'},
          {id: 2, text: '承诺配货率'},
          {id: 1, text: '实际配货率'}
        ], // 配货率类型下拉列表
        selectSymbolType: 0, // 选择的符号
        symbolType: [
          {id: 0, text: '符号'},
          {id: 1, text: '='},
          {id: 2, text: '>'},
          {id: 3, text: '>='},
          {id: 4, text: '<'},
          {id: 5, text: '<='}
        ], // 符号类型下拉列表
        num: '', // 数值
        todayDeliveryChannel: false, // 是否显示今天提供的发货渠道
        isLoading: false, // 是否显示加载框
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    methods: {
      // 根据渠道编号/名称 + 渠道类型 + 锁定状态 + 配货率类型 + 符号 + 数值 + 是否显示今天提供的发货渠道
      queryData() {
        this.currentPage = 1;
        this.loadProxyAllStoreroomPageData();
      },

      // 加载渠道列表分页数据
      loadProxyAllStoreroomPageData() {
        this.isLoading = true;
        this.list = [];
        const params = {
          idorName: this.numOrName,
          storeroomType: this.selectChannelType,
          // lockStatus: this.selectLockedStatus,
          rateType: this.selectDistributionType,
          symbol: this.selectSymbolType,
          rateValue: parseFloat(this.num),
          isShowToday: this.todayDeliveryChannel,
          IsReOrder: this.selectReSales,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.loadProxyAllStoreroomPageData, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            if (res.data) {
              clearTimeout(timer);
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
                self.list = [];
                self.total = 0;
              }
            }
          }, 500);
        });
      },

      // 操作按钮
      ctrlBtn(type, channelMsg) {
        this.isShow = true;
        this.dialogShowType = type;
        this.channelMsg = channelMsg;
        switch (type) {
          case 'channelDetail':
            this.dialogTitle = '渠道详情';
            break;
          case 'openAfterSale': case 'closeAfterSale':
          this.dialogTitle = '渠道自收';
            break;
        }
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType) {
          this.loadProxyAllStoreroomPageData();
        }
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.loadProxyAllStoreroomPageData();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadProxyAllStoreroomPageData();
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      this.loadProxyAllStoreroomPageData();
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.numOrName = '';
        this.selectChannelType = 0;
        this.selectReSales = null;
        this.selectDistributionType = 0;
        this.selectSymbolType = 0;
        this.num = '';
        this.todayDeliveryChannel = false;
        this.isShow = false;
        this.currentPage = 1;
        this.pageSize = 10;
        this.total = 0;
        this.loadProxyAllStoreroomPageData();
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .channel_list {
    .channel_list_top {
      position: relative;

      & > div {
        width: 11%;
        margin-right: 0.5%;
      }

      button {
        position: absolute;
        right: 2%;
      }

      .wper5 {
        width: 5%;
      }

      .wper13 {
        width: 13%;
      }

      .wper15 {
        width: 15%;
      }

      .wper19 {
        width: 19%;
      }

      .w46 {
        width: 46px;
      }

      .w70 {
        width: 70px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/channel-list.vue